import './LabelGroup-eda75c0f.css';

var classes = {"OverlayContainer":"prc-LabelGroup-OverlayContainer-pt4uv","OverlayInner":"prc-LabelGroup-OverlayInner-qvwGT","CloseButton":"prc-LabelGroup-CloseButton-GyJi3"};

export { classes as default };
